class SimpleSlider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector(".simple-slider_track");
    this.items = Array.from(this.track.children);
    this.prevBtn = slider.querySelector(".simple-slider_btn.prev");
    this.nextBtn = slider.querySelector(".simple-slider_btn.next");
    this.dotsContainer = slider.querySelector(".simple-slider_dots");

    this.total = this.items.length;
    this.index = 0;

    // Get custom small screen size from data attribute (default = 750)
    this.smallScreenSize =
      parseInt(this.slider.getAttribute("data-sm-screen")) || 750;

    this.createDots();
    this.prevBtn.addEventListener("click", () => this.prev());
    this.nextBtn.addEventListener("click", () => this.next());

    this.checkSmallScreen();
    this.goTo(this.index, false);

    // Handle resize
    window.addEventListener("resize", () => {
      this.checkSmallScreen();
      this.goTo(this.index, false);
    });
  }

  goTo(index, transition = true) {
    this.track.style.transition = transition ? "transform 0.5s ease" : "none";
    this.track.style.transform = `translateX(-${index * 100}%)`;
    this.updateDots();
  }

  next() {
    this.index++;
    if (this.index >= this.total) {
      this.index = 0;
      this.goTo(this.index, true);
    } else {
      this.goTo(this.index);
    }
  }

  prev() {
    this.index--;
    if (this.index < 0) {
      this.index = this.total - 1;
      this.goTo(this.index, true);
    } else {
      this.goTo(this.index);
    }
  }

  createDots() {
    this.dotsContainer.innerHTML = '';
    this.dots = [];
    for (let i = 0; i < this.total; i++) {
      const dot = document.createElement("span");
      dot.classList.add("simple-slider_dot");
      dot.addEventListener("click", () => {
        this.index = i;
        this.goTo(this.index);
      });
      this.dotsContainer.appendChild(dot);
      this.dots.push(dot);
    }
  }

  updateDots() {
    this.dots.forEach((dot) => dot.classList.remove("active"));
    this.dots[this.index].classList.add("active");
  }

  checkSmallScreen() {
    if (window.innerWidth < this.smallScreenSize && this.items.length > 1) {
      this.index = 1;
      this.prevBtn.style.display = "none";
      this.nextBtn.style.display = "none";
    } else {
      this.index = 0;
      this.prevBtn.style.display = "block";
      this.nextBtn.style.display = "block";
    }
  }
}
